module.exports = __webpack_public_path__ + "static/screenie_search_4-af6d1452e50a33d9eecd809807041ae0.jpg";